module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step5-FR.c9193797.png";